export const sortPts = 
    (pts) => {
        let _pts = [0,1,2];
        let getX = (pt) => pts[2*pt];
        let getY = (pt) => pts[2*pt+1];
        _pts.sort(
            (a,b) => getY(a) === getY(b) ? getX(a) - getX(b) : getY(a) - getY(b));

        let ret = [];
        _pts.forEach(
            pt => {
                ret.push(getX(pt));
                ret.push(getY(pt));
            });
        return ret;
    };
